module.exports = "/public/images/ed03d3487ac0ce1ae301f3158118f573.jpg";